import { render, staticRenderFns } from "./GlobalListener.vue?vue&type=template&id=850a86f0&scoped=true"
import script from "./GlobalListener.vue?vue&type=script&lang=js"
export * from "./GlobalListener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850a86f0",
  null
  
)

export default component.exports